import { forumStats } from '@/mocks/rankings';

const milestones = [
  { year: '2018', title: '论坛创立', description: '海角论坛正式上线，以技术交流为核心板块，首年注册用户突破5万。' },
  { year: '2019', title: '板块扩展', description: '新增生活分享、数码产品、游戏娱乐三大板块，社区内容更加丰富多元。' },
  { year: '2020', title: '用户破百万', description: '注册用户突破100万，成为国内知名的综合性交流社区平台。' },
  { year: '2021', title: 'App上线', description: '海角论坛移动端App正式发布，让用户随时随地畅享社区互动。' },
  { year: '2022', title: '内容升级', description: '引入优质创作者激励计划，内容质量和社区活跃度大幅提升。' },
  { year: '2023', title: '生态完善', description: '新增职场教育、汽车出行板块，日活跃用户突破3万。' },
  { year: '2024', title: '技术革新', description: '全面升级技术架构，推出AI智能推荐系统，用户体验大幅优化。' },
  { year: '2025', title: '品牌升级', description: '全新品牌形象上线，社区规范和内容审核机制进一步完善。' },
  { year: '2026', title: '持续成长', description: '累计帖子突破895万，持续为用户提供优质的社区交流体验。' },
];

const features = [
  { icon: 'ri-shield-check-line', title: '严格内容审核', description: '多层审核机制，确保内容质量与社区秩序' },
  { icon: 'ri-user-star-line', title: '优质创作者', description: '汇聚各领域优秀创作者，产出高质量原创内容' },
  { icon: 'ri-message-3-line', title: '活跃社区', description: '日均3.5万活跃用户，交流氛围热烈友好' },
  { icon: 'ri-smartphone-line', title: '多端访问', description: '支持Web端和移动App，随时随地参与讨论' },
];

export default function Reputation() {
  return (
    <section className="py-14 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            品牌声誉与发展历程
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto">
            八年深耕，持续成长，用优质内容和服务赢得用户信赖
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {features.map((feat) => (
            <div key={feat.title} className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center hover:border-primary-200 transition-all">
              <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className={`${feat.icon} text-primary-600 text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">{feat.title}</h3>
              <p className="text-xs text-foreground-600">{feat.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8 mb-10">
          <h3 className="text-lg font-bold text-foreground-950 mb-6 font-heading text-center">发展里程碑</h3>
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 transform md:-translate-x-px"></div>
            <div className="space-y-6">
              {milestones.map((item, idx) => (
                <div key={item.year} className={`relative flex items-start gap-4 md:gap-8 ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-full z-10 text-xs font-bold">
                    {item.year.slice(2)}
                  </div>
                  <div className={`flex-1 bg-background-100 rounded-lg p-4 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                    <div className="text-xs text-primary-600 font-semibold mb-1">{item.year}</div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h4>
                    <p className="text-xs text-foreground-600">{item.description}</p>
                  </div>
                  <div className={`flex-1 hidden md:block ${idx % 2 === 0 ? '' : ''}`}></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
            <div className="text-2xl font-bold text-primary-600 font-heading">{(forumStats.totalMembers / 10000).toFixed(0)}万</div>
            <div className="text-sm text-foreground-600 mt-1">注册会员</div>
          </div>
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
            <div className="text-2xl font-bold text-accent-600 font-heading">{(forumStats.totalPosts / 10000).toFixed(0)}万</div>
            <div className="text-sm text-foreground-600 mt-1">帖子总数</div>
          </div>
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
            <div className="text-2xl font-bold text-primary-600 font-heading">{forumStats.onlineUsers.toLocaleString()}</div>
            <div className="text-sm text-foreground-600 mt-1">当前在线</div>
          </div>
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
            <div className="text-2xl font-bold text-accent-600 font-heading">{forumStats.todayPosts.toLocaleString()}</div>
            <div className="text-sm text-foreground-600 mt-1">今日新帖</div>
          </div>
        </div>
      </div>
    </section>
  );
}